module.exports = __webpack_public_path__ + "img/android5bg5.5a969753.png";